(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-fsp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('.home-fsp [data-parallax]');
    if (!el || !window.matchMedia('(min-width: 900px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false, visible = false;
    function update() {
      ticking = false;
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var p = (vh - r.top) / (vh + r.height);
      if (p < 0) p = 0; if (p > 1) p = 1;
      el.style.setProperty('--py', p.toFixed(4));
    }
    function onScroll() { if (visible && !ticking) { ticking = true; requestAnimationFrame(update); } }
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) update(); }).observe(el);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cost-transparency"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cost-select]');
    var dataEl = document.querySelector('[data-cost-data]');
    if (!root || !dataEl) return;
    var trigger = root.querySelector('[data-cost-trigger]');
    var menu = root.querySelector('[data-cost-menu]');
    var nameEl = root.querySelector('[data-cost-name]');
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-value]'));
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var rows = document.querySelectorAll('.costpage__row[data-key]');
    var totalEl = document.querySelector('[data-total]');
    var fee = totalEl ? parseInt(totalEl.getAttribute('data-fee') || '0', 10) : 0;
    function money(c) { return '$' + (c / 100).toFixed(2); }
    function show(handle) {
      var d = data[handle];
      if (!d) return;
      var total = fee;
      rows.forEach(function (row) {
        var k = row.getAttribute('data-key');
        var out = row.querySelector('[data-amount]');
        if (!out || !k || k === 'fee') return;
        var c = d[k] || 0;
        out.textContent = c > 0 ? money(c) : '';
        row.hidden = !(c > 0) && row.getAttribute('data-show-empty') !== 'true';
        total += c;
      });
      if (totalEl) totalEl.textContent = money(total);
    }
    function close() { menu.hidden = true; trigger.setAttribute('aria-expanded', 'false'); }
    function open() {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      var sel = root.querySelector('[aria-selected="true"]') || options[0];
      if (sel) sel.focus();
    }
    function choose(btn) {
      options.forEach(function (o) {
        var on = o === btn;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        o.classList.toggle('al-select__option--selected', on);
      });
      if (nameEl) nameEl.textContent = btn.querySelector('span').textContent;
      show(btn.getAttribute('data-value'));
      close();
      trigger.focus();
    }
    trigger.addEventListener('click', function () { menu.hidden ? open() : close(); });
    options.forEach(function (btn, i) {
      btn.addEventListener('click', function () { choose(btn); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var next = options[(i + (e.key === 'ArrowDown' ? 1 : options.length - 1)) % options.length];
          if (next) next.focus();
        } else if (e.key === 'Escape') { close(); trigger.focus(); }
      });
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { close(); trigger.focus(); } });
  })();

  } catch(e) { console.error(e); }
})();
})();
